import { lazy } from 'react';

import { BaseRoles, RoleVariantEnum } from 'common/graphql/types';
import { SUPPORT_ROLES } from 'common/utils/user';
export const routes = [
    {
        component: lazy(() => import('module/activitylibrary/ActivityLibraryList')),
        permissions: ['Study_Library_Read'],
        role: [
            BaseRoles.AdminId,
            BaseRoles.UserId,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.StudySupport,
            RoleVariantEnum.Librarian,
            RoleVariantEnum.AdminReadOnly,
            ...SUPPORT_ROLES,
        ],
        path: '/',
    },
];
